import React from 'react';

const fmtTime = (ts) => {
  if (!ts) return '';
  const d = new Date(ts);
  return isNaN(d) ? '' : d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
};

export const PresentStaffChips = ({ staff = [] }) => (
  <div className="flex-[2] w-full min-w-0" data-testid="present-staff-list">
    <p className="text-xs uppercase tracking-wide text-gray-500 mb-2">Clocked in now ({staff.length})</p>
    {staff.length === 0 ? (
      <p className="text-sm text-gray-400" data-testid="present-staff-empty">No one is clocked in right now.</p>
    ) : (
      <div className="flex flex-wrap gap-2 max-h-28 overflow-y-auto pr-1">
        {staff.map((s) => (
          <a
            key={s.employee_id}
            href={`/employees?focus=${encodeURIComponent(s.employee_id)}`}
            target="_blank"
            rel="noopener noreferrer"
            title="Open profile in a new tab"
            className="inline-flex items-center gap-1.5 rounded-full border border-emerald-200 bg-white px-3 py-1 text-xs text-gray-800 hover:border-emerald-400 hover:bg-emerald-50 transition-colors"
            data-testid={`present-staff-chip-${s.employee_code || s.employee_id}`}
          >
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
            <span className="font-medium">{s.name}</span>
            {fmtTime(s.clock_in) && <span className="text-gray-500">· {fmtTime(s.clock_in)}</span>}
          </a>
        ))}
      </div>
    )}
  </div>
);
